import React, { Component } from 'react'
import { Card, Button, Modal } from 'antd'
import {
  Editor,
  EditorState,
} from 'draft-js';
import "draft-js/dist/Draft.css";
import {
  insertFun, myKeyBindingFn, getValue,
  getHtml, getContentStateToRowForJson, styles, compositeDecorator, refreshByContentStateToRowJson
} from './SICommon';
const ButtonGroup = Button.Group;

const mathOperators = [{ name: '+', code: '+' },
{ name: '-', code: '-' },
{ name: '×', code: '*' },
{ name: '/', code: '/' },
{ name: '%', code: '%' },
{ name: '^', code: '^' },
{ name: '(', code: '(' },
{ name: ')', code: ')' },
// { name: '()', code: '()' },
];

const logicOperators = [
  { name: 'and', code: '&&' },
  { name: 'or', code: '||' },
  { name: 'not', code: '!' }
];

const relationOperators = [
  { name: '>', code: '>' },
  { name: '<', code: '<' },
  { name: '>=', code: '>=' },
  { name: '<=', code: '<=' },
  { name: '=', code: '==' },
  { name: '!=', code: '!=' },
];

const varOperators = [
  { name: '变量符', code: '#{}' }
];

export class SICondition extends Component {
  constructor(props) {
    super(props);
    let initData = this.props.contentStateToRowJson;
    let editorState;
    if (initData) {
      editorState = refreshByContentStateToRowJson.call(this, initData);
    } else {
      editorState = EditorState.createEmpty(compositeDecorator);
    }

    this.state = {
      editorState,
      visible: false,
      loading: true
    };
  }

  focus = () => this.refs.editor.focus();

  handleKeyCommand(command) {
    if (command === 'myeditor-save') {
      this.showModal();
      return 'handled';
    }
    return 'not-handled';
  }

  showModal = () => this.setState({ visible: true });
  closeModal = (e) => this.setState({ visible: false });
  _onChange = (editorState,e,e2) => {
    this.setState({ editorState });
    let onChange = this.props.onChange;
    if (onChange && typeof onChange === "function") {
      onChange(this,e,e2);
    }
  };

  // 导入common中的方法
  insertVariate = insertFun.bind(this, "variable");
  insertConstant = insertFun.bind(this, "constant");
  getValue = getValue.bind(this);
  getHtml = getHtml.bind(this);
  getContentStateToRowForJson = getContentStateToRowForJson.bind(this);
  refreshByContentStateToRowJson = refreshByContentStateToRowJson.bind(this);


  getButtons(){
      let mathbuttons=[];
        let len=mathOperators.length;
      for(let i=0;i<len; i++){
        mathbuttons.push(<Button key={mathOperators[i].code} onClick={this.insertConstant.bind(this, mathOperators[i].name, mathOperators[i].code)}>{mathOperators[i].name}</Button>);
      }
      let logicbuttons=[];
      for(let i=0;i<logicOperators.length; i++){
        logicbuttons.push(<Button key={logicOperators[i].code} onClick={this.insertConstant.bind(this, logicOperators[i].name, logicOperators[i].code)}>{logicOperators[i].name}</Button>);
      }
      let relationbuttons=[];
      for(let i=0;i<relationOperators.length; i++){
        relationbuttons.push(<Button key={relationOperators[i].code} onClick={this.insertConstant.bind(this, relationOperators[i].name, relationOperators[i].code)}>{relationOperators[i].name}</Button>);
      }
      let varbuttons=[];
      for(let i=0;i<varOperators.length; i++){
        varbuttons.push(<Button key={varOperators[i].code}  onClick={this.insertConstant.bind(this, varOperators[i].name, varOperators[i].code)}>{varOperators[i].name}</Button>);
      }
      let button=(<div><ButtonGroup>{mathbuttons}</ButtonGroup>&nbsp;&nbsp;<ButtonGroup>{logicbuttons}</ButtonGroup>&nbsp;&nbsp;<ButtonGroup>{relationbuttons}</ButtonGroup>&nbsp;&nbsp;<ButtonGroup>{varbuttons}</ButtonGroup>&nbsp;&nbsp;</div>);

      return button;
  }
  componentDidUpdate(){
     if (!this.state.loading){
        this.focus();
        this.setState({loading:true});
     }
  }
  render() {
    let buttons = this.getButtons();
    tool.sgiLogger.log(this.getValue());
    return (
      <div>
        <Card
          title={this.props.title}
          extra={buttons}
          style={{ width: '100%' }}
        >
          <div style={styles.editor} onClick={this.focus}>
            <Editor
              editorState={this.state.editorState}
              onChange={this._onChange}
              handleKeyCommand={this.handleKeyCommand}
              keyBindingFn={myKeyBindingFn}
              // placeholder="Enter some text..."
              ref="editor"
            />
          </div>
                    {/* <input
                    onClick={this.getValue.bind(this)}
                    style={styles.button}
                    type="button"
                    value="获取数据"
                />
                <input
                    onClick={this.getHtml.bind(this)}
                    style={styles.button}
                    type="button"
                    value="获取html"
                />
                <input
                    onClick={this.getContentStateToRowForJson.bind(this)}
                    style={styles.button}
                    type="button"
                    value="getContentStateToRowForJson"
                /> */}
        </Card>
      </div>
    )
  }
}

export default SICondition;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/SIDef/SICondition.js